import { StateToken } from '@ngxs/store';
import { CastingStateModel } from './casting.state-model';

export const CASTING_STATE_TOKEN = new StateToken<CastingStateModel>('casting');
